module.exports = __webpack_public_path__ + "img/background2.2cf7bf31.jpeg";